import React from "react";

export default function HealLogPanel({ healLog, onClose }) {
  return (
    <div style={{
      position: "fixed", top: 50, right: 280, width: 280,
      background: "#09090f", border: "1px solid #fb923c30",
      borderRadius: 8, padding: "14px", zIndex: 50, boxShadow: "0 12px 32px #000c",
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
        <span style={{ fontSize: 8, color: "#fb923c", letterSpacing: 2, fontWeight: 800 }}>AUTO-HEAL LOG</span>
        <button onClick={onClose} style={{ background: "transparent", border: "none", color: "#4a5e70", cursor: "pointer", fontSize: 12 }}>✕</button>
      </div>

      {(healLog || []).length === 0 && (
        <div style={{ fontSize: 9, color: "#1e2a3a" }}>No corrections made yet.</div>
      )}

      {[...(healLog || [])].reverse().map((entry, i) => (
        <div key={i} style={{ padding: "6px 8px", background: "#0c1320", borderRadius: 4, marginBottom: 4, border: "1px solid #1a2636" }}>
          <div style={{ fontSize: 7.5, color: "#3d5068", marginBottom: 3 }}>
            {new Date(entry.ts).toLocaleTimeString()}
          </div>
          {entry.changes.map((c, j) => (
            <div key={j} style={{ fontSize: 8.5, color: "#fb923c", display: "flex", alignItems: "center", gap: 5 }}>
              <span style={{ color: "#4ade80", fontSize: 8 }}>⟳</span>{c}
            </div>
          ))}
        </div>
      ))}

      <div style={{ marginTop: 10, fontSize: 7.5, color: "#1e2a3a", lineHeight: 1.7 }}>
        All corrections are automatic and non-destructive.<br />
        Your intent is always preserved.
      </div>
    </div>
  );
}
